import { useEffect } from 'react'
import { setSourceCentricDetailsActive } from './sourceCentricProductHeaderInterceptor'

export default function useSourceCentricProductHeader(isSourceCentricDetails: boolean): void {
  // Set synchronously so the flag is active before SWR fires its initial requests on mount
  setSourceCentricDetailsActive(isSourceCentricDetails)

  useEffect(() => {
    return () => setSourceCentricDetailsActive(false)
  }, [])
}
